import { ReactNode } from "react";
import { cn } from "../ClassName";
import { createPortal } from "react-dom";

interface Props {
  hideModal: () => void;
  children: ReactNode;
  style?: string;
  enablePreventDefault?: boolean; // Defaults to True
  disableBackdropClose?: boolean; // When true, clicking the backdrop does not close the modal. Defaults to False.
  dataTestId?: string;
}

export function Modal(props: Props) {
  const modal = (
    <div
      id="modal-background"
      className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[9999] tw-h-[100vh] tw-w-[100vw] tw-transform-gpu tw-overflow-auto tw-bg-gray-2 tw-bg-opacity-50"
      data-testid={props.dataTestId}
      onClick={(e) => {
        if (
          !props.disableBackdropClose &&
          e.target === document.getElementById("modal-background")
        ) {
          props.hideModal();
        }
      }}
    >
      <div
        className={cn(
          "tw-mx-auto tw-mt-[20%] tw-min-h-fit tw-w-[40%] tw-overflow-y-auto tw-rounded-xl tw-border-[1px] tw-border-solid tw-border-gray-2/50 tw-bg-white",
          props.style,
        )}
        onClick={(e) => {
          if (props.enablePreventDefault != false) {
            e.preventDefault();
          }
        }}
      >
        {props.children}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
